import { useTranslation } from "react-i18next";
import { Icon, Message, MessageContent, MessageHeader } from "semantic-ui-react";

import "modules/LocationLicenseOverview/components/LocationInvoiceDisabledMessage/LocationInvoiceDisabledMessage.scss";
import { useLocationLicensesDashboardFilters } from "modules/LocationLicenseOverview/components/LocationLicenseFilters/hooks";

export const LocationInvoiceDisabledMessage = () => {
  const { t } = useTranslation();

  const { location } = useLocationLicensesDashboardFilters();

  return (
    <div className="LocationInvoiceDisabledMessage">
      <Message icon className="message-container">
        <div className="icon-placement">
          <Icon className="exclamation triangle red" size="big" />
        </div>
        <MessageContent>
          <MessageHeader>
            <span className="header-title">
              {t(
                "v8_invoicing_is_not_enabled_for_this_location_enable_it_in_the_location_settings",
                "Invoicing is not enabled for this location. Enable it in the location settings."
              )}
            </span>
          </MessageHeader>
          <span className="header-text">{location?.name}</span>
        </MessageContent>
      </Message>
    </div>
  );
};
